<div
  class="search-result-detail {{ profileCssClass }} {{ searchTypeCssClass }}"
  *ngIf="searchResult.type == typeFilter || typeFilter == 'all'">
  <h2 *ngIf="searchResult.data.firstName">
    <a [routerLink]="placeLink" class="search-result-detail-icons">
      <span>{{ searchResult.data.firstName }} {{ searchResult.data.lastName }}</span>
      <span
        *ngIf="searchResult.data.isAffiliatedProvider"
        class="ic-status-affiliated"
        title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy. Click the 'Who can I find
 here?' link for more information."></span>
      <span *ngIf="searchResult.data.isConsultant" class="is-consultant" title="{{ settings.values.consultIconTitle }}">
      </span>
      <span
        *ngIf="searchResult.data.isTelehealth"
        class="is-telehealth"
        title="{{ settings.values.virtualConsultationTitle }}"></span>
    </a>
  </h2>
  <h3 class="specialty" *ngIf="searchResult.data.specialist">
    {{ searchResult.data.specialist }}
  </h3>
  <div class="special-interests" *ngIf="searchResult.data.specialInterest">
    Special interest(s): {{ searchResult.data.specialInterest }}
  </div>
  <h2 *ngIf="searchResult.data.practiceName">
    <a [routerLink]="placeLink">
      <span>{{ searchResult.data.practiceName }}</span>
      <span
        *ngIf="searchResult.data.isAffiliatedProvider"
        class="ic-status-affiliated"
        title="An Affiliated Provider will organise prior approval with
 us and claim on your behalf for eligible healthcare
 services - so you don't need to submit a claim. You
 may need to see an Affiliated Provider in order to be
 covered under your policy. Click the 'Who can I find
 here?' link for more information."></span>
      <span
        *ngIf="searchResult.data.isEasyClaim"
        class="ic-status-easy-claim"
        title="Easy-Claim is a convenient way for Southern Cross
 members to claim for eligible day-to-day healthcare
 services at participating partners at the time of
 purchase. Click the 'Who can I find here?' link for
 more information."></span>
      <span
        *ngIf="searchResult.data.isConsultant"
        class="is-consultant"
        title="{{ settings.values.consultIconTitle }}"></span>
    </a>
  </h2>
  <ul class="plain-list" *ngIf="searchResult.data.phones">
    <li *ngFor="let phone of searchResult.data.phones">
      <span
        [ngClass]="{ 'ic-phone': true }"
        *ngIf="phone.number"
        [innerHTML]="phone.number | phoneLinkedWithDescription: phone.description"></span>
      <span
        [ngClass]="{ 'ic-phone': true }"
        *ngIf="!phone.number"
        [innerHTML]="phone | phoneLinkedWithDescription: null"></span>
    </li>
  </ul>
  <div *ngIf="searchResult.data.address" class="ic-address">
    <div
      class="facility-name"
      *ngIf="searchResult.data.facilityName && searchResult.data.facilityName !== searchResult.data.address">
      {{ searchResult.data.facilityName }}
    </div>
    <div *ngIf="searchResult.data.receptionLocation">
      {{ searchResult.data.receptionLocation }}
    </div>
    {{ searchResult.data.address }}
    <div *ngIf="searchResult.data.suburb">{{ searchResult.data.suburb }}</div>
    <div *ngIf="searchResult.data.city || searchResult.data.postcode">
      {{ searchResult.data.city }} {{ searchResult.data.postcode }}
    </div>
  </div>
  <div><a (click)="viewMapClicked()" class="link-button">View map</a></div>
  <div class="ic-web" *ngIf="searchResult.data.webAddress">
    <a href="{{ searchResult.data.webAddress }}" target="_newtab">{{ searchResult.data.webAddress | webAddress }}</a>
  </div>
  <div *ngIf="profileCssClass != 'place-profile'">
    <div class="ic-email" *ngIf="searchResult.data.emailAddress" aria-label="Email">
      <a href="mailto:{{ searchResult.data.emailAddress }}">{{ searchResult.data.emailAddress }}</a>
    </div>
  </div>
  <h4 class="service-categories" *ngIf="searchResult.data.serviceCategoryNames.length > 0"> Service category </h4>
  <ul>
    <li *ngFor="let serviceCategory of searchResult.data.serviceCategoryNames">
      {{ serviceCategory }}
    </li>
  </ul>
  <div class="search-result-buttons">
    <button class="people" *ngIf="typeFilter === filterType.people" [routerLink]="placeLink">
      Check services
      <span class="arrow-right"></span>
    </button>

    <button class="places" *ngIf="typeFilter === filterType.places" [routerLink]="placeLink">
      View facility details
      <span class="arrow-right"></span>
    </button>
  </div>
</div>
